import {
    currentSearchAtom,
    departureAirportAtom,
    departureDateAtom,
    destinationAtom,
    destinationLabelAtom,
    hotelSortOrderAtom,
    paginationAtom,
    occupancyAtom,
    offerSortOrderAtom,
    regionSortOrderAtom,
    returnDateAtom,
    sortingAtom,
    travelDurationAtom,
    travelPeriodAtom,
    cityIdListAtom,
    regionIdListAtom,
} from 'data/Atom/Search';

import { Iata } from 'types/Search/airport';
import { AirportValue } from 'types/Search/filter';
import {
    DestinationValue,
    DurationValue,
    Occupancy,
    Pagination,
    Search,
    Sorting,
    SortOrder,
    TravelPeriod,
} from 'types/Search/form';
import { FormStateHook } from 'types/Search/hook';

import { useSearchAtom } from './useSearchAtom';
import { useSetSearchAtom } from './useSetSearchAtom';

export const useCurrentSearch: FormStateHook<Search> = () =>
    useSearchAtom(currentSearchAtom);

// for only batch setting the current search, without reading it
export const useSetCurrentSearch = () => useSetSearchAtom(currentSearchAtom);

export const useDestination: FormStateHook<DestinationValue> = () =>
    useSearchAtom(destinationAtom);

export const useCityFilter: FormStateHook<Set<number>> = () =>
    useSearchAtom(cityIdListAtom);

export const useSetCityFilter = () => useSetSearchAtom(cityIdListAtom);

export const useRegionFilter: FormStateHook<Set<number>> = () =>
    useSearchAtom(regionIdListAtom);

export const useSetDestinationLabel = () =>
    useSetSearchAtom(destinationLabelAtom);

export const useDepartureAirport: FormStateHook<AirportValue<Iata>> = () =>
    useSearchAtom(departureAirportAtom);

export const useTravelPeriod: FormStateHook<TravelPeriod> = () =>
    useSearchAtom(travelPeriodAtom);

export const useTravelDuration: FormStateHook<DurationValue> = () =>
    useSearchAtom(travelDurationAtom);

export const useDepartureDate: FormStateHook<Date | undefined> = () =>
    useSearchAtom(departureDateAtom);

export const useReturnDate: FormStateHook<Date | undefined> = () =>
    useSearchAtom(returnDateAtom);

export const useOccupancy: FormStateHook<Occupancy> = () =>
    useSearchAtom(occupancyAtom);

export const usePagination: FormStateHook<Pagination> = () =>
    useSearchAtom(paginationAtom);

export const useSetPagination = () => useSetSearchAtom(paginationAtom);

export const useSorting: FormStateHook<Sorting> = () =>
    useSearchAtom(sortingAtom);

export const useRegionSorting: FormStateHook<SortOrder | undefined> = () =>
    useSearchAtom(regionSortOrderAtom);

export const useHotelSorting: FormStateHook<SortOrder | undefined> = () =>
    useSearchAtom(hotelSortOrderAtom);

export const useOfferSorting: FormStateHook<SortOrder | undefined> = () =>
    useSearchAtom(offerSortOrderAtom);
